<template>
  <div
    class="book-page"
  >
    <van-swipe
      ref="book-swiper"
      class="book-swiper"
      indicator-color="white"
      vertical
      :autoplay="0"
      :loop="true"
      @change="currentChange"
    >
      <van-swipe-item
        v-for="(img, index) in BOOK_INFO"
        :key="index"
        class="swiper-item flx-col-ctr"
        height="calc(100vh - 54px)"
      >
        <template v-if="current == index">
          <!-- <van-image
            :src="img"
            :show-error="false"
            :show-loading="false"
            height="500%"
            style="filter: blur(5px)"
            class="abs animated1s fadeIn"
          /> -->
          <van-image
            :src="img"
            :show-error="false"
            :show-loading="false"
            height="100%"
            fit="contain"
            class="animated1s fadeIn"
          />
        </template>
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          <span
            v-for="(num, index) in BOOK_INFO.length"
            :key="num"
            :class="['item', current === index ? 'current' : '']"
            @click="changeCurrent(num -1)"
          />
          <!-- <van-image
            :show-loading="false"
            :src="require('@/imgs/dot.png')"
            lazy-load
            fit="fill"
            @click="changeCurrent(num -1)"
          /> -->
          <!-- <span
            class="select-dot"
            :style="{top: `${current * 22}px`}"
          /> -->
        </div>
      </template>
    </van-swipe>
  </div>
</template>

<script>
import { BOOK_INFO } from '@/libs/config/book';
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      BOOK_INFO,
      current: 0,
    };
  },
  methods: {
    currentChange(index) {
      this.current = index;
    },
    changeCurrent(index) {
      this.current = index;
      this.$refs['book-swiper'].swipeTo(index);
    },
  },
};
</script>

<style lang="less" scope>
@contentMT: 5vh;
.book-page {
  width: 10rem;
  height: calc(100vh - 54px);
  background-color: #fefefe;
  background-size: cover;
  background-position: 100%;
  .bg-img {
    filter: blur(50px);
  }
  .custom-indicator {
    position: absolute;
    z-index: 10;
    right: .5rem;
    top: 25vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .item {
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background: #faf6f3;
      margin-right: 10px;
      transition: all .5s linear;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      &.current {
        height: 20px;
        background-color: #f2a434;
      }
    }
    // .select-dot {
    //   position: absolute;
    //   left: 0;
    //   top: 54px;
    //   width: 10px;
    //   height: 30px;
    //   border-radius: 50px;
    //   background-color: #f2a434;
    //   transition: top .5s ease-in-out;
    // }
  }
  .book-swiper {
    width: 10rem;
    height: 100%;
  }
  .swiper-item {
    width: 10rem;
    height: 100%;
  }
  .title {
    margin-top: 3vh;
  }
  .content {
    margin-top: 3vh;
  }
  .foot {
    margin-top: 4vh;
  }
}
</style>
